var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "removeComponentModal",
    attrs: {
      id: "remove-component-modal",
      "footer-close-button-text": _vm.$t("global.words.no"),
    },
    on: { hide: _vm.hidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              " " + _vm._s(_vm.$t("application-form.confirmChanges")) + " "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: { "class-name": "btn btn-primary" },
                on: { click: _vm.handleAcceptDeletion },
              },
              [_vm._v(_vm._s(_vm.$t("global.words.yes")) + "\n    ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }